export const SET_VIEWER_DATA = "@USER/SET_VIEWER_DATA";

export const USER_LOGIN_START = "@USER/LOGIN_START";
export const USER_LOGIN_SUCCESS = "@USER/LOGIN_SUCCESS";
export const USER_LOGIN_FAILED = "@USER/LOGIN_FAILED";

export const USER_LOGOUT_EXPIRED = "@USER/LOGOUT_EXPIRED";
export const USER_LOGOUT = "@USER/LOGOUT";
